export default "__VITE_ASSET__86dd7c19__"